import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";

var _createReducer;

import { createReducer } from 'redux-act';
import { sendSmsVerification, verifySmsCode, backToMobileStep, jumpToVerifyStep, createTUCustomer } from "../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, sendSmsVerification.success, function (state, payload, meta) {
  return _objectSpread(_objectSpread({}, state), {}, {
    mobileNumber: meta.mobileNumber,
    smsCodeStep: true
  });
}), _defineProperty(_createReducer, sendSmsVerification.fail, function (state, payload) {
  var smsCodeStep = state.smsCodeStep,
      successfullyVerified = state.successfullyVerified;

  if (_get(payload, 'data.error.data.internal_message') === 'phone number associated with identity is already verified') {
    smsCodeStep = true;
    successfullyVerified = true;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    smsCodeStep: smsCodeStep,
    successfullyVerified: successfullyVerified
  });
}), _defineProperty(_createReducer, verifySmsCode.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    successfullyVerified: true
  });
}), _defineProperty(_createReducer, verifySmsCode.fail, function (state) {
  return _objectSpread({}, state);
}), _defineProperty(_createReducer, backToMobileStep, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    smsCodeStep: false
  });
}), _defineProperty(_createReducer, jumpToVerifyStep, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    smsCodeStep: true
  });
}), _defineProperty(_createReducer, createTUCustomer.fail, function (state, payload) {
  var internal_message = payload.internal_message,
      phone_number = payload.phone_number,
      require_sms = payload.require_sms;
  var smsVerificationRequired = require_sms || internal_message === 'User requires SMS verification';
  return _objectSpread(_objectSpread({}, state), {}, {
    verificationRequired: smsVerificationRequired,
    mobileNumber: phone_number
  });
}), _createReducer), {});